import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HrRoutingModule } from './hr-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/material.module';
import { HrPageComponent } from './components/hr-page/hr-page.component';
import { AdminHrComponent } from './components/admin-hr/admin-hr.component';


@NgModule({
  declarations: [HrPageComponent, AdminHrComponent],
  imports: [
    CommonModule,
    HrRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class HrModule { }
